import { asBlob } from "html-docx-js-typescript";
import { buildWordReportHtml } from "./report-export-template";

const buildSafeFileName = (name) =>
  name.replace(/[\\/:*?"<>|]/g, "").replace(/\s+/g, "_");

export const exportESGReportToWord = async (payload) => {
  const html = buildWordReportHtml(payload);
  const blob = await asBlob(html);
  const dateSuffix = new Date().toISOString().slice(0, 10);
  const safeParts = [
    payload.reportName || "ESG_Report",
    payload.framework,
    payload.orgName,
    dateSuffix,
  ]
    .filter(Boolean)
    .map(buildSafeFileName);
  const fileName = `${safeParts.join("_")}.docx`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return fileName;
};
